import React from 'react';
import { 
  Button,
  Icon,
  useDisclosure
} from '@chakra-ui/react';
import { FaCommentAlt } from 'react-icons/fa';
import FeedbackModal from '../User/FeedbackModal';

const HelpOptionButton = () => {
  // Disclosure for feedback modal
  const feedbackModal = useDisclosure();
  
  return (
    <>      <Button 
        leftIcon={<Icon as={FaCommentAlt} />} 
        size="sm" 
        colorScheme="blue" 
        variant="ghost"
        onClick={feedbackModal.onOpen}
      >
        Feedback
      </Button>
      
      {/* Feedback Modal */}
      <FeedbackModal isOpen={feedbackModal.isOpen} onClose={feedbackModal.onClose} />
    </>
  );
};

export default HelpOptionButton;
